import { BehaviorSubject } from "rxjs";
import { Menu } from "../interface/menu";

export const menuItems: Menu[] = [
  {
    main_title: "Aplicaciones",
  },
  {
    path: "/reservations",
    id: "reservations",
    title: "Reservaciones",
    icon: "calendar",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/wallets",
    id: "wallets",
    title: "Wallet de clientes",
    icon: "wallet-point",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/branches",
    id: "branches",
    title: "Sucursales",
    icon: "maps",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/currencies",
    id: "currencies",
    title: "Monedas",
    icon: "price",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/users",
    id: "users",
    title: "Usuarios",
    icon: "user",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/promotions",
    id: "promotions",
    title: "Promociones",
    icon: "price",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    id: "lealtad",
    title: "Lealtad",
    icon: "bonus-kit",
    type: "sub",
    active: false,
    bookmark: true,
    level: 1,
    children: [
      {
        path: "/puntos",
        id: "puntos",
        title: "Puntos",
        type: "link",
        level: 2,
      },
      {
        path: "/referrals/config",
        id: "referrals-config",
        title: "Config. Referidos",
        type: "link",
        level: 2,
      },
      {
        path: "/referrals/tracking",
        id: "referrals-tracking",
        title: "Seguimiento Referidos",
        type: "link",
        level: 2,
      },
    ],
  },
  {
    path: "/point-rules",
    id: "point-rules",
    title: "Matriz de Puntos",
    icon: "bonus-kit",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/marketplace",
    id: "marketplace",
    title: "Marketplace de Recompensas",
    icon: "bonus-kit",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/pages/document-requirements",
    id: "document-requirements",
    title: "Reqs. de Documentación",
    icon: "file",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/pages/home-banners",
    id: "home-banners",
    title: "Banners de Inicio",
    icon: "gallery",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/pages/hero-sections",
    id: "hero-sections",
    title: "Secciones Hero",
    icon: "layout",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/pages/screens",
    id: "screens",
    title: "Pantallas",
    icon: "tv",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/pages/faq",
    id: "faq",
    title: "Preguntas frecuentes",
    icon: "faq",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    main_title: "Configuraciones",
  },
  {
    path: "/roles",
    id: "roles",
    title: "Roles",
    icon: "user",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/team",
    id: "team",
    title: "Equipo",
    icon: "user",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/operating-hours",
    id: "operating-hours",
    title: "Horarios y estados operativos",
    icon: "calendar",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/metric-exclusions",
    id: "metric-exclusions",
    title: "Exclusión en Métricas",
    icon: "user",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    main_title: "Sistema",
  },
  {
    path: "/app-tokens",
    id: "app-tokens",
    title: "Tokens de sistema",
    icon: "ui-kits",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/core-environments",
    id: "core-environments",
    title: "Entornos Core",
    icon: "ui-kits",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    path: "/webhook-subscriptions",
    id: "webhook-subscriptions",
    title: "Suscripciones Webhook",
    icon: "ui-kits",
    type: "link",
    bookmark: true,
    level: 1,
  },
  {
    id: "settings",
    title: "Configuración",
    icon: "ui-kits",
    type: "sub",
    active: false,
    bookmark: true,
    level: 1,
    children: [
      {
        path: "/settings",
        id: "settings-general",
        title: "General",
        type: "link",
        level: 2,
      },
      {
        path: "/settings/notifications",
        id: "settings-notifications",
        title: "Notificaciones",
        type: "link",
        level: 2,
      },
    ],
  },
  {
    path: "/legal",
    id: "legal",
    title: "Legales",
    icon: "file",
    type: "link",
    bookmark: true,
    level: 1,
  },
];

// Array
export const items = new BehaviorSubject<Menu[]>(menuItems);
